// Terugknop: een stap terug in de geschiedenis als de bezoeker van binnen de
// winkel komt. Anders volgt de browser gewoon de href van de link.
document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-leni-back]');
  if (!link) return;
  if (window.history.length <= 1 || !document.referrer) return;

  try {
    if (new URL(document.referrer).origin !== window.location.origin) return;
  } catch (error) {
    return;
  }

  event.preventDefault();
  window.history.back();
});
